<template>
	<div class="basis-page-cls tel-status-setting">
		<div class="basis-cls_filter tel-status-setting__tools">
			<h3>电话状态配置</h3>
			<p>
				<el-button size="mini" type="primary" icon="el-icon-plus" @click="handleCreate">添加置忙选项</el-button>
			</p>
		</div>
		<div class="basis-cls_table tel-status-setting__table">
			<table-pagination ref="dragTables" 
				:data="list"
				:column="column"
				row-key="auxId"
				style="height: 100%;"
				v-loading="loading">
					<template v-slot:action="{row}">
						<div class="operate-inline">
							<el-button type="text" size="small" @click="handelEdit(row)">编辑</el-button>
						</div>
					</template>
					<template v-slot:isOnline="{row,  $index}">
						<el-switch @change="switchOnline(row, $index)" v-model="row.isOnline" active-value="1" inactive-value="0"></el-switch>
					</template>
					<template v-slot:isEnabled="{row, $index}">
						<el-switch @change="switchStatus(row, $index)" v-model="row.isEnabled" active-value="0" inactive-value="1"></el-switch>
					</template>
			</table-pagination>
		</div>
		<el-drawer 
            :title="dialog_status == 'create' ? '新增' : '修改'" 
            :visible.sync="dialog_visible_touch_in"
            :wrapperClosable="false"
			:modal-append-to-body="false"
			size="600px"
            direction="rtl">
            <el-form :model="aux_form" ref="aux_form" labelPosition="right" autoComplete="on" labelWidth="120px">
				<el-form-item prop="auxDesc" label="置忙选项：" :rules="[{required: true, trigger: 'blur', message: '请输入置忙选项'}]">
                    <el-input v-model="aux_form.auxDesc" placeholder="请输入置忙选项" style="width:450px;" maxlength="50" show-word-limit clearable></el-input>
                </el-form-item>
				<el-divider></el-divider>
                <el-form-item style="float: right;padding-right: 30px;">
                    <el-button @click="dialog_visible_touch_in = false">取 消</el-button>
					<el-button @click.stop="create" :loading="loading" type="primary" v-if="dialog_status === 'create'">提 交</el-button>
                    <el-button @click.stop="update" :loading="loading" type="primary" v-else>保 存</el-button>
                </el-form-item>
            </el-form>
        </el-drawer>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters([
			'userInfo',
		]),
	},
	data(){
		return {
			loading:false,
			column:[
				{
					label: '优先级',
					width: 80,
					align: 'center',
					render: (h, scope) => {
						return (
							<span>{((this.listQuery.pageNumber - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
						)
					}
				},
				{label: "置忙选项", prop: "auxDesc"},
				{ 
					renderHeader:(h,scope) => {
						return <div><span>能否外呼</span>
							<el-tooltip content = "开启后，该置忙选项选中后，坐席可外呼" placement = "top" >
								<i class= "el-icon-info"></i>
							</el-tooltip>
						</div>
					},
					prop: "isOnline",
					slotScope:true
				},
				{
					renderHeader:(h,scope) => {
						return <div><span>开启</span>
							<el-tooltip content = "开启后，软电话置忙的下拉列表会出现此项；关闭后，下拉列表不会出现此项" placement = "top" >
								<i class= "el-icon-info"></i>
							</el-tooltip>
						</div>
					},
					prop: "isEnabled", 
					slotScope:true
				},
				{label: "操作", prop: "action", slotScope:true, width: 80, fixed:'right', align: "center"},
			],
			listQuery:{
				pageNumber: 1,
				pageSize: 100,
				auxType: '0',
				projectCode: ''
			},
			list: [],
			dialog_visible_touch_in: false,
			dialog_status: 'create',
			aux_form: {
				projectCode: '',
				auxDesc: '',
				auxType: '0',
				isOnline: '0'
			}
		}
	},
	created(){
		this.getList()
	},
	methods: {
		getList() {
			const self = this;
			self.loading = true;
			self.listQuery.projectCode = self.userInfo.brandIdentify;
			self.$api.apiPostLarkswitchAuxConfigList(self.listQuery).then(response => {
				if(response.errcode != 0) {
					self.loading = false;
					return;
				};
				self.list = response.data;
				self.$nextTick(() => {
					self.initDrag();
				});
				self.loading = false;
			})
		},
		initDrag(){
			const tbody = this.$refs.dragTables.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0] // table
			let sortAble = Sortable.create(tbody,{
				sort: true,
				animation: 150,
				filter: ".disabled",
				dataIdAttr: 'data-index',
				onMove:(event,originalEvent) => {
					if(event.related.className.indexOf('disabled') !== -1) return false;
				},
				onEnd:(evt) => {
					const currRow = this.list.splice(evt.oldIndex, 1)[0]
					this.list.splice(evt.newIndex, 0, currRow);
					this.setData();
				}
			})
		},
		setData(){
			const newData = [];
			this.list.map((item, index) => {
				newData.push([item.auxId, index + 1])
			})
			this.$api.apiPostLarkswitchAuxConfigDragOrder({ sorts: newData}).then(res => {
				// if(res.errcode != 0) return;
				this.getList();
			})
		},
		switchOnline(row, index) {
			row.isOnline === '0' ? '0' : '1'
            this.$api.apiPostLarkswitchAuxConfigEdit(row).then(response => {
				if(response.errcode != 0) return;
				this.$notify({
					title: `修改成功`,
					offset: 70,
					type: "success"
				});
				this.getList();
			}).catch(error => {
				this.list[index].isOnline = row.isOnline === '0' ? '1' : '0';
			});
        },
		switchStatus(row, index) {
			row.isEnabled === '0' ? '0' : '1'
            this.$api.apiPostLarkswitchAuxConfigEdit(row).then(response => {
				if(response.errcode != 0) return;
				this.$notify({
					title: `修改成功`,
					offset: 70,
					type: "success"
				});
				this.getList();
			}).catch(error => {
				this.list[index].isEnabled = row.isEnabled === '0' ? '1' : '0';
			});
        },
		handleCreate() {
			this.resetForm();
			this.dialog_visible_touch_in = true;
			this.dialog_status = 'create';
		},
		handelEdit(row) {
			this.resetForm();
			this.dialog_visible_touch_in = true;
			this.dialog_status = 'update';
			this.aux_form = Object.assign(this.aux_form, row);
		},
		create() {
            this.$refs["aux_form"].validate(valid => {
                if (valid) {
                    this.loading = true;
					this.aux_form.projectCode = this.userInfo.brandIdentify;
                    this.$api.apiPostLarkswitchAuxConfigCreate(this.aux_form).then(response => {
						if(response.errcode != 0) {
							this.loading = false;
							return;
						};
                        this.$notify({
                            title: "新增成功",
                            offset: 70,
                            type: "success"
                        });
                        this.dialog_visible_touch_in = false;
						this.loading = false;
                        this.getList();
                    }).catch(error => {
						this.loading = false;
					});
                }
            });
		},
		update() {
            this.$refs["aux_form"].validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.$api.apiPostLarkswitchAuxConfigEdit(this.aux_form).then(response => {
						if(response.errcode != 0) {
							this.loading = false;
							return;
						};
                        this.$notify({
                            title: "编辑成功",
                            offset: 70,
                            type: "success"
                        });
                        this.dialog_visible_touch_in = false;
						this.loading = false;
                        this.getList();
                    }).catch(error => {
						this.loading = false;
					});
                }
            });
		},
		resetForm() {
			this.aux_form = {
				projectCode: '',
				auxDesc: '',
				auxType: '0',
				isOnline: '0'
			}
			if (this.$refs["aux_form"]) {
				this.$refs["aux_form"].clearValidate();
			}
		},
	}
}
</script>
<style lang="scss" scoped>
	.tel-status-setting {
		&__tools {
			display: flex;
			justify-content: space-between;
			h3 {
				font-size: 14px;
				font-weight: bold;
				color: #3C4353;
			}
		}
		&__table {
			::v-deep .el-table tbody {
				cursor: move;
			}
			::v-deep .el-table .disabled {
				background: #eee;
				cursor: not-allowed;
			}
		}
	}
</style>
